import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux";
import { FacultyType, ProfileStudent } from "../Utils/DataType";
import useFetch from "../hooks/useFetch";
import { useEffect, useState } from "react";
import InputValidate from "./InputValidate";
import UtilFunctions, { Transition } from "../Utils/UtilFucntion";
import { LoadingButton } from "@mui/lab";
import SendAndArchiveRoundedIcon from '@mui/icons-material/SendAndArchiveRounded';
import AxiosClient from "../api/AxiosClient";
import { setProfle } from "../redux/ProfileSlice";
import { log } from "console";

type props = {
    show: boolean,
    setShow: Function
}

export default function DialogProfile({ show, setShow }: props) {
    let profile = useSelector<RootState, ProfileStudent>(state => state.profile);
    let dataFaculty = useFetch('faculties', false);
    let dataMajor = useFetch('majors', false);
    const [dataForm, setDataForm] = useState<{ email: string, phone: string }>({ email: profile.email, phone: profile.phone });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    let dispatch = useDispatch();

    function getFaculty(id: number): string {
        let list: FacultyType[] = dataFaculty.response;
        if (!list) return 'loading...';

        let index = list.find((item) => item.id === id);
        if (!index) return 'loading...';
        return index.name;
    }

    function getMajor(id: number): string {
        let list: FacultyType[] = dataMajor.response;
        if (!list) return 'loading...';

        let index = list.find((item) => item.id === id);
        if (!index) return 'loading...';
        return index.name;
    }

    function onChangeData(field: string, value: string) {
        setDataForm({ ...dataForm, [field]: value });
    }

    function onSubmit(): void {
        let data = { ...profile, email: dataForm.email, phone: dataForm.phone };

        setIsLoading(true);
        AxiosClient.put(`students/${profile.id}`, data).then(() => {
            UtilFunctions.showToastSuccess('Cập nhật thành công!');
            dispatch(setProfle(data));
            setIsLoading(false);
        }).catch(() => {
            UtilFunctions.showToastSuccess('Đã xảy ra lỗi!');
        })
    }

    useEffect(()=>{
        console.log(dataFaculty.response)
    }, [dataFaculty.response])

    return (
        <div>
            <Dialog
                open={show}
                onClose={() => setShow(false)}
                fullWidth
                maxWidth='sm'
                TransitionComponent={Transition}
            >
                <DialogTitle>
                    <div className="text-[#0d47a1]">Thông tin cá nhân</div>
                </DialogTitle>
                <DialogContent>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <span className="font-semibold text-[#616161]">Họ và tên: </span> <span className="font-semibold text-[#1565c0]">{`${profile.first_name} ${profile.last_name}`}</span>
                        </div>
                        <div>
                            <span className="font-semibold text-[#616161]">Ngày sinh: </span> <span className="font-semibold text-[#1565c0]">{profile.birthday}</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-4 gap-4">
                        <div>
                            <span className="font-semibold text-[#616161]">Mã số sinh viên: </span> <span className="font-semibold text-[#1565c0]">{profile.student_id}</span>
                        </div>
                        <div>
                            <span className="font-semibold text-[#616161]">Giới tính: </span> <span className="font-semibold text-[#1565c0]">{profile.gender}</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-4 gap-4">
                        <div>
                            <span className="font-semibold text-[#616161]">Khoa: </span> <span className="font-semibold text-[#1565c0]">{getFaculty(profile.faculty_id)}</span>
                        </div>
                        <div>
                            <span className="font-semibold text-[#616161]">Ngành: </span> <span className="font-semibold text-[#1565c0]">{getMajor(profile.major_id)}</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-6 gap-4">
                        <InputValidate label={"Email: "} name={"email"} onChangeData={onChangeData} value={dataForm.email} isValid={UtilFunctions.isValidEmail(dataForm.email)} alert={"Email không hợp lệ"} disabled={false} placeholder={"Email"} type={"text"} />
                        <InputValidate label={"Số điện thoại:"} name={"phone"} onChangeData={onChangeData} value={dataForm.phone} isValid={UtilFunctions.isValidPhone(dataForm.phone)} alert={"SĐT không hợp lệ"} disabled={false} placeholder={"Số điện thoại"} type={"text"} />
                    </div>
                </DialogContent>
                <div className="p-4 flex justify-end">
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        variant="contained"
                        startIcon={<SendAndArchiveRoundedIcon />}
                        onClick={onSubmit}
                    >
                        Cập nhật
                    </LoadingButton>
                </div>
            </Dialog>
        </div>
    )
}